// Vue
import {mixins} from 'vue-class-component'
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Mixins
import {EventBus} from '../../../mixins/event_bus/EventBus'

// Utils
import {StringFormat} from '../../../utils/StringFormat'

// Components'
import {Container} from '../container/Container'
import {Icon} from '../icon/Icon'

@Component({
    name: 'FilterBar',
    components: {
        Container,
        Icon,
    },
    mixins: [
        template,
    ]
})
export class FilterBar extends mixins(EventBus) {

    public get hasSelectedFilters() {

        return Object.values(this.value).some(value => {
            // @ts-ignore
            return (value instanceof  Array && value.length > 0) || (value.toString().length > 0) || false
        })
    }

    public get filterBarItemGroups() {

        let filterBarItemsLength = Object.keys(this.filterBarItemsMap).length
        let filterBarItemGroups: any[] = []
        let filterBarItemGroup: any = {}

        Object.keys(this.filterBarItemsMap).forEach((key, index) => {

            filterBarItemGroup[key] = this.filterBarItemsMap[key]

            if (index + 1 % this.rowSize == 0 || index == filterBarItemsLength - 1) {

                filterBarItemGroups.push(filterBarItemGroup)
                filterBarItemGroup = {}
            }
        })

        return filterBarItemGroups
    }

    public openedFilterBarItem: string = ''
    public filterBarItemsMap: {[key: string]: {title: string, icon?: string, iconFile?: string}} = {}
    public isSticky: boolean = false

    public $el!: HTMLElement

    public $refs!: {
        filter_bar: HTMLElement
    }

    @Prop({type: [Object]})
    public value!: any

    @Prop({default: 5})
    public rowSize!: number

    public created() {
       this.$on('registerFilterBarItem', this.handleFilterBarItemRegister)
       this.$on('closeFilterBarItem', this.handleCloseFilterBarItem)

       window.addEventListener('scroll', this.handleScroll)
       window.addEventListener('click', this.handleCloseFilterBarItem)
    }

    public mounted() {
        this.broadcast('FilterBarItem', 'changeOpenedFilterBarItem', [this.openedFilterBarItem])

       this.handleScroll(undefined)
    }

    public destroyed() {
        this.$off('registerFilterBarItem', this.handleFilterBarItemRegister)
        this.$off('closeFilterBarItem', this.handleCloseFilterBarItem)

        window.removeEventListener('scroll', this.handleScroll)
        window.addEventListener('click', this.handleCloseFilterBarItem)
    }

    public handleFilterBarItemRegister(filterBarItemMap: {title: string, icon?: string, iconFile?: string, selected: string[]}) {

         Vue.set(this.filterBarItemsMap, StringFormat.slugify(filterBarItemMap.title), filterBarItemMap)
    }

    public handleToggleFilterBarItem(filterBarItem: string) {

        this.openedFilterBarItem = filterBarItem == this.openedFilterBarItem ? '' : filterBarItem

        this.broadcast('FilterBarItem', 'changeOpenedFilterBarItem', [this.openedFilterBarItem])
    }

    public handleCloseFilterBarItem(e?: any) {

        if (!e || e.target.contains(this.$refs.filter_bar) || !this.$refs.filter_bar.contains(e.target)) {
            this.openedFilterBarItem = ''
            this.broadcast('FilterBarItem', 'changeOpenedFilterBarItem', [this.openedFilterBarItem])
        }
    }

    public handleScroll(e) {

        const fixedFooterElement = <HTMLElement>document.querySelector(`.${this.$appPrefix}-fixed-footer`)

        let filterBarBottom = 0;

        if (fixedFooterElement) {
            filterBarBottom += fixedFooterElement.offsetHeight
        }

        if ((this.$el.parentElement!.getBoundingClientRect().top + this.$refs.filter_bar.offsetHeight) < (window.innerHeight - filterBarBottom) &&
            (window.innerHeight - filterBarBottom) < (this.$el.getBoundingClientRect().top + this.$refs.filter_bar.offsetHeight)) {

            this.isSticky = true

            this.$el.style.height = this.$refs.filter_bar.offsetHeight + 'px'
            this.$refs.filter_bar.style.bottom = filterBarBottom + 'px'
        } else if (false) {

        } else {
            this.isSticky = false
            this.$el.style.height = ''
            this.$refs.filter_bar.style.bottom = ''
        }
    }

    public handleRemoveFilter(name: string, filter: any) {

        const value = this.value

        if (value[name] instanceof Array) {

            if (value[name].includes(filter)) value[name].splice(value[name].indexOf(filter), 1)
        } else {
            value[name] = ''
        }

        this.$emit('input', value)
    }

    public hasFilterValues(filter: any) {

        return filter instanceof  Array ? filter.length > 0 : filter.toString().length > 0
    }
}